module.exports = __webpack_public_path__ + "img/Banner-Who-is-your-customer.fa9eba54.png";